import React, { useMemo, useState } from 'react';

import { useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  CreateRaindropFormContext,
  CreateRaindropFormState,
  createRaindropFormStateDefault,
  createRaindropSchemaDefault,
} from '@Forms/raindrop/CreateRaindropFormContext';

export const CreateRaindropFormProvider: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateRaindropFormState>>>(
    createRaindropSchemaDefault
  );
  const methods = useForm({
    defaultValues: createRaindropFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateRaindropFormContext.Provider value={value}>
      {children}
    </CreateRaindropFormContext.Provider>
  );
};
